import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { Device, DeviceDTO } from '../models/DeviceDTO.model';
import { SendSmsRequest } from '../models/sendSMS/SendSmsRequest';
import { SendSmsResponse } from '../models/sendSMS/SendSmsResponse';

@Injectable({
  providedIn: 'root'
})

export class SendsmsService {

  constructor(private httpService: HttpService) {}

    getDevicesByCustomer() {
      return this.httpService.get<Device[]>( ApiRoutesEnum.getDevicesByCustomer).pipe(tap((data) => {}));
    }

    sendSMS(request: SendSmsRequest) {
      return this.httpService.post<SendSmsResponse>( ApiRoutesEnum.SendSMS, request).pipe(tap((data) => {}));
    }
}
